import { motion } from "framer-motion";
import React from "react";
import { FaGithub, FaLinkedinIn } from "react-icons/fa";
import { useLanguage } from "../context/LanguageContext";


const Footer = () => {
	const { t } = useLanguage();
	return (
		<footer className="bg-gray-900 dark:bg-gray-800 text-white py-6 md:py-8 transition-colors duration-300">
			<div className="container mx-auto px-4">
				<div className="flex flex-col items-center md:flex-row md:justify-between">
					<div className="mb-6 md:mb-0 text-center md:text-left">
						<h2 className="text-xl font-bold">{t("portfolio")}</h2>
						<p className="text-gray-400 mt-1 text-sm md:text-base">
							© {new Date().getFullYear()} All rights reserved.
						</p>
					</div>

					

					<div className="flex space-x-4">
						<motion.a
							href="https://github.com/zwarmex"
							target="_blank"
							rel="noopener noreferrer"
							whileHover={{ scale: 1.2, y: -3 }}
							className="hover:text-blue-400 transition-all">
							<FaGithub className="text-xl" />
						</motion.a>
						<motion.a
							href="https://linkedin.com/in/julien-pollart"
							target="_blank"
							rel="noopener noreferrer"
							whileHover={{ scale: 1.2, y: -3 }}
							className="hover:text-blue-400 transition-all">
							<FaLinkedinIn className="text-xl" />
						</motion.a>
						{/* <motion.a
							href="https://twitter.com/yourusername"
							target="_blank"
							rel="noopener noreferrer"
							whileHover={{ scale: 1.2, y: -3 }}
							className="hover:text-blue-400 transition-all">
							<FaTwitter className="text-xl" />
						</motion.a> */}
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
